// extracted by mini-css-extract-plugin
module.exports = {"ldsRing":"loading-module--lds-ring--_CvT0"};